<template>
    <div>
        <h5 v-if="filter.title" v-text="filter.title" class="filter-title mb-1" />
        <ui-virtual-list
            :label="filter.label"
            :module-name="filter.moduleName"
            :getter="filter.getter"
            :multi="filter.multi"
            :fetch-action="filter.fetchAction"
            :fetch-on-init="filter.fetchOnInit"
            :searcher="filter.searcher"
            :value="filter.value"
            :background-color="filter.backgroundColor"
            :color="filter.color"
            :options="filter.options"
            @change="$emit('set-filter', $event)"
        />
    </div>
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>